import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import CustomModal from "../ui/modal/modal.component";
import { EditProfile } from "../../workspaces/profile/editProfile/editProfile.component";
import { useAuthContext } from "../../contexts/auth";

const COMPLETE_PROFILE_DISMISSED_KEY = "completeProfileModalDismissed";

export const CompleteProfileModal = () => {
  const { t } = useTranslation();
  const { currentUser } = useAuthContext();
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const isMissingName = !currentUser.first_name || !currentUser.last_name;
    const isDismissed = sessionStorage.getItem(COMPLETE_PROFILE_DISMISSED_KEY) === "true";

    if (isMissingName && !isDismissed) {
      setOpened(true);
    }
  }, [currentUser]);

  const handleDismiss = (value: boolean) => {
    if (!value) {
      sessionStorage.setItem(COMPLETE_PROFILE_DISMISSED_KEY, "true");
    }
    setOpened(value);
  };

  const content = (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("Please provide your first and last name to complete your profile.")}
      </Typography>
      <EditProfile onSuccess={() => setOpened(false)} />
    </>
  );

  return (
    <CustomModal
      opened={opened}
      setOpened={handleDismiss}
      title={t("Complete your profile")}
      content={content}
      width={500}
    />
  );
};
